// extracted by mini-css-extract-plugin
export default {"wrapper":"MezzaDetails_wrapper__nPMiV"};